export const WHATSAPP_LINK = "https://chat.whatsapp.com/Fm6OQuxxPKV5MgG3pbh88v";
export const REVEAL_DATE = "2026-09-01T00:00:00+05:30";
export const MIK_LOGO = "https://d502jbuhuh9wk.cloudfront.net/logos/61ed5fc60cf20fb614a95a0d.png";
export const HERO_GLOW_IMG = "https://static.prod-images.emergentagent.com/jobs/5213ee71-8f8e-42e7-97b9-f2fc42a23ba9/images/4a03fb726bfb02fb20b82a58ab4d6bb3e9a86ac629e6439b467bb7e07fc403c2.jpeg";
